import { useEffect } from "react"

const deepClone = (obj) => JSON.parse(JSON.stringify(obj))

const unique = (arr) => [...new Set(arr)]

const roadLayers = unique([
  "road-motorway",
  "road-trunk",
  "road-secondary",
  "road-tertiary",
  "road-street",
  "road-service",
  "road-path",
  "road-motorway-case",
  "road-secondary-case",
  "road-trunk-case",
  "road-trunk-case-link",
  "road-tertiary-case",
  "road-motorway-link",
  "road-trunk-link",
  "road-motorway-link-case",
  "road-trunk-link-case",
  "road-link",
  "road-link-case",
  "road-minor",
  "road-minor-case",
  "bridge-motorway-trunk-2",
  "bridge-motorway-trunk-2-case",
  "bridge-motorway-trunk",
  "bridge-motorway-trunk-case",
  "bridge-major-link",
  "bridge-major-link-case",
  "road-minor-link",
  "road-major-link",
  "road-major-link-case",
  "road-minor-link-case",
  "road-street-case",
  "bridge-major-link-2",
  "bridge-major-link-2-case",
])

const roadLayersMain = [
  "road-motorway-trunk",
  "road-primary",
  "road-primary-case",
  "road-primary-link",
]

const landUseLayers = ["landuse", "landcover"]
const greenLayers = [
  "landuse-park",
  "landcover-grass",
  "landcover-wood",
  "national-park",
]
const waterLayers = ["water", "water-shadow"]
const poiLayers = [
  "poi-label",
  "poi-scalerank1",
  "poi-scalerank2",
  "poi-scalerank3",
]

function applyPaintToLayers(style, layers, paintProps) {
  layers.forEach((layerId) => {
    const layer = style.layers.find((l) => l.id === layerId)
    if (layer && layer.paint) {
      layer.paint = { ...layer.paint, ...paintProps }
    }
  })
}

function applyLayoutToLayers(style, layers, layoutProps) {
  layers.forEach((layerId) => {
    const layer = style.layers.find((l) => l.id === layerId)
    if (layer && layer.layout) {
      layer.layout = { ...layer.layout, ...layoutProps }
    }
  })
}

function getFadedMapStyle(baseStyleJson) {
  // Deep clone so we don’t mutate the original style
  const style = deepClone(baseStyleJson)

  applyPaintToLayers(style, roadLayers, {
    "line-color": "#BBBBBB",
    "line-opacity": 0.3,
  })

  applyPaintToLayers(style, roadLayersMain, {
    "line-color": "#59636E",
    "line-opacity": 0.3,
  })

  applyPaintToLayers(style, landUseLayers, {
    "fill-color": "#F6F2E4",
    "fill-opacity": 0.2,
  })

  applyPaintToLayers(style, greenLayers, {
    "fill-color": "#D9F4D6",
    "fill-opacity": 0.5,
  })

  applyPaintToLayers(style, waterLayers, {
    "fill-color": "#B4EAFC",
    "fill-opacity": 0.5,
  })

  applyLayoutToLayers(style, poiLayers, {
    visibility: "none",
  })

  // Handle "building" fill-opacity
  const buildingLayer = style.layers.find((l) => l.id === "building")
  if (buildingLayer && buildingLayer.paint) {
    buildingLayer.paint["fill-opacity"] = 0.1
  }

  return style
}

const fetchBaseStyle = async (token) => {
  const styleUrl = `https://api.mapbox.com/styles/v1/mapbox/streets-v12?access_token=${token}`

  const res = await fetch(styleUrl)
  if (!res.ok) throw new Error("Failed to fetch base style")

  return res.json()
}

export function MapStyleHook(set_map_style) {
  useEffect(() => {
    const loadStyle = async () => {
      const baseStyle = await fetchBaseStyle(process.env.REACT_APP_MAPBOX_TOKEN)
      const fadedStyle = getFadedMapStyle(baseStyle)
      set_map_style(fadedStyle)
    }
    loadStyle().catch(console.error)
  }, [set_map_style])
}
